import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en/translation.json";
import esTranslation from "./es/translation.json";

// Get saved language from localStorage or default to 'en'
const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('preferred-language');
  if (saved && ['en', 'es'].includes(saved)) {
    return saved;
  }
  
  // Fallback to browser language detection
  const browserLang = navigator.language.split('-')[0];
  return ['en', 'es'].includes(browserLang) ? browserLang : 'en';
};

i18next
  .use(initReactI18next)
  .init({
    debug: false,
    lng: getSavedLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {translation: enTranslation},
      es: {translation: esTranslation},
    },
  });
